// src/features/tag-types/hooks/useTagTypePermissions.ts

import { usePermissions } from 'react-admin';
import { TagType } from '../types';

export const useTagTypePermissions = (record?: TagType) => {
  const { permissions: role } = usePermissions<'SuperAdmin' | string>();

  const isSuperAdmin = role === 'SuperAdmin';

  const canManage = isSuperAdmin;
  const canCreate = isSuperAdmin;
  const canEdit = isSuperAdmin;
  const canDelete = isSuperAdmin;
  
  // Lógica para editar/borrar un registro específico
  // Los TagTypes generados por el sistema no se pueden editar ni borrar
  const canEditThis = record ? isSuperAdmin : canEdit;
  const canDeleteThis = record ? isSuperAdmin : canDelete;

  return {
    isSuperAdmin,
    canManage,
    canCreate,
    canEdit,
    canDelete,
    canEditThis,
    canDeleteThis,
  };
};